/**
 * Generated by "@vuepress/internal-routes"
 */

import { injectComponentOption, ensureAsyncComponentsLoaded } from '@app/util'
import rootMixins from '@internal/root-mixins'
import GlobalLayout from "/usr/local/share/.config/yarn/global/node_modules/@vuepress/core/lib/client/components/GlobalLayout.vue"

injectComponentOption(GlobalLayout, 'mixins', rootMixins)
export const routes = [
  {
    name: "v-24521a4c",
    path: "/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-24521a4c").then(next)
    },
  },
  {
    path: "/index.html",
    redirect: "/"
  },
  {
    name: "v-ab8ab24a",
    path: "/f41/t1.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-ab8ab24a").then(next)
    },
  },
  {
    name: "v-70c813d7",
    path: "/f41/t3.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-70c813d7").then(next)
    },
  },
  {
    name: "v-9404c9d2",
    path: "/f42/t4.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-9404c9d2").then(next)
    },
  },
  {
    name: "v-4318750f",
    path: "/f42/t8.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-4318750f").then(next)
    },
  },
  {
    name: "v-265f2b8d",
    path: "/f42/t9.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-265f2b8d").then(next)
    },
  },
  {
    name: "v-7c8b0813",
    path: "/f42/t6.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-7c8b0813").then(next)
    },
  },
  {
    name: "v-5fd1be91",
    path: "/f42/t7.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-5fd1be91").then(next)
    },
  },
  {
    name: "v-cd775cd6",
    path: "/f42/t5.html",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-cd775cd6").then(next)
    },
  },
  {
    path: '*',
    component: GlobalLayout
  }
]